export default __webpack_public_path__ + "focus.svg-foreign-object-hack-63a2.js";